
document.addEventListener("DOMContentLoaded", function() {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
   //Comment me out to see issue
   gsap.config({ nullTargetWarn: false });
   const screenWidth = window.innerWidth;
       scrollSmoother = ScrollSmoother.create({
            wrapper: "#smooth-wrapper",
            content: "#smooth-content",
            smooth: screenWidth <= 1025 ? 0.8 : 1.3, // Lower for iPad
            effects: screenWidth <= 1025 ? false : true, 
            normalizeScroll: true,
            ignoreMobileResize: true, 
        });
   

    let mm = gsap.matchMedia();

    // Hero banner animation  
 

    mm.add("(min-width:768px)", () => {
        // sessionStorage.getItem('site-loader-loaded') == 'true'
        // let siteLoaded = true;
        // if(siteLoaded) {
        //     document.querySelector('.site-loader')?.classList.add('d-none');
        //     gsap.timeline({
        //         onComplete: () => {
        //             document.body.classList.remove('scroll-fixed-loader');
        //         }
        //     })
        //     .fromTo('.hero-content',{yPercent: 101, opacity: 0, duration: 1},{yPercent: 0, opacity: 1, duration: 1}, '-=0.5')
        //     .from('.hero-swiper-pagination', {opacity: 0, duration: 1})
        // } else {
        //     document.body.classList.add('scroll-fixed-loader');
        //     gsap.timeline({
        //         onComplete: () => {
        //             document.body.classList.remove('scroll-fixed-loader');
        //         }
        //     })
        //     .to(".site-loader ", {yPercent:-100, duration: 1, delay: 2, ease:"none"})
        //     .fromTo('.hero-content',{yPercent: 101, opacity: 0, duration: 1},{yPercent: 0, opacity: 1, duration: 1}, '-=0.5')
        //     .from('.hero-swiper-pagination', {opacity: 0, duration: 1})
        //     sessionStorage.setItem('site-loader-loaded', 'true');
        // }

        gsap.fromTo('.hero-content',{yPercent: 101, opacity: 0, duration: 1},{yPercent: 0, opacity: 1, duration: 1}, '-=0.5')
        gsap.from('.hero-swiper-pagination', {opacity: 0, duration: 1})
    });

    //Banner Slider animation  


    mm.add("(min-width:992px)", () => {

        let panel = document.querySelector(".heading-bar");
        let moveText = document.querySelector('.heading-bar h2');
        let productsList = document.querySelector(".products-list");

        gsap.to(".home-product-slider-section", {
            scrollTrigger: {
                trigger: ".home-product-slider-section", // Ensure correct trigger
                start: "20% 35%",
                end: "100% 35%",
                pin: true, // Pin the section
                scrub: 1, // Smooth effect
                markers: false, // Disable markers for production
                onEnter: () => document.querySelector(".products-list")?.classList.add("completed"),
                onLeaveBack: () => document.querySelector(".products-list")?.classList.remove("completed"),
            },
        });
        

        gsap.to(panel, {
            scrollTrigger: {
                trigger: panel,
                start: "top+=25% top",
                endTrigger: ".home-product-slider-section",
                end: "bottom 35%",
                pin: true, // Pin the section
                scrub: 1, // Smooth effect
                pinSpacing: false,
                markers: false // Disable markers for production
            }
        });


        // if (panel) {
        //     // Pin the panel
        //     ScrollTrigger.create({
        //         trigger: panel,
        //         start: "top top",
        //         pin: true,
        //         scrub: 0.5,
        //         duration: 0.5,
        //         pinSpacing: false,
        //         markers: false // Disable markers for production
        //     });
        // }
        // Define the timeline for the text movement
        // let tl = gsap.timeline()
        //     .to(moveText, {
        //         yPercent: -250,
        //         duration: 0.8, 
        //         delay: 0.9,
        //         ease: "none" 
        //     });

        // let stackSt = ScrollTrigger.create({
        //     trigger: panel, 
        //     animation: tl, 
        //     start: "top top",
        //     end: "bottom top",
        //     scrub: 0.5, 
        //     markers: false,
        //     onUpdate: (self) => {
        //         const progressThreshold = 0.7; // Define progress threshold for clarity
        //         if (self.progress >= progressThreshold) {
        //             productsList.classList.add("completed");
        //         } else {
        //             productsList.classList.remove("completed");
        //         }
        //     }
        // });
    });

   

    mm.add("(min-width:768px)", () => {
        // Scale Video Animation
        let updateBgColor = document.querySelector('.scale-animation');

        // Background Color Change Trigger
        ScrollTrigger.create({
            trigger: updateBgColor,
            start: "top top",
            end: "bottom top",
            onEnter: () => {
                gsap.to(updateBgColor, { backgroundColor: "#1a1a1a", duration: 1 });
                updateBgColor.classList.add("active");
            },
            onLeaveBack: () => {
                gsap.to(updateBgColor, { backgroundColor: "#f6f6f6", duration: 1 });
                updateBgColor.classList.remove("active");
            }
        });

        // Scale animation timeline
        let splitTimeline = gsap.timeline()
            .from(".scale-animation .banner__media", { scaleX: 0.225, scaleY: 0.16, duration: 1, ease: "none" })
            .to({}, { duration: 0.5 })
        
        let splitSt = ScrollTrigger.create({
            animation: splitTimeline,
            trigger: ".scale-animation",
            pin: true,
            start: "top top",
            end: "+=250%", // Extend animation duration
            scrub: 0.5,
            anticipatePin: 1,
            fastScrollEnd: false,
            markers: false,
            onUpdate: (self) => {
                const target = document.querySelector(".scale-animation .banner__media");
                const computedStyle = window.getComputedStyle(target);
                const matrix = computedStyle.transform;
    
                if (matrix) {
                // Extract scaleX from the matrix
                const values = matrix.match(/matrix\(([^)]+)\)/)[1].split(", ");
                const scaleX = parseFloat(values[0]);
    
                if (scaleX >= 0.9) {
                    document.querySelector(".scale-animation").classList.add("completed");
                    } else {
                        document.querySelector(".scale-animation").classList.remove("completed");
                    }
                }
            },
            onEnterBack: () => {
                document.querySelector(".scale-animation").classList.remove("completed");
            }
        });
    });
     mm.add("(min-width:768px)", () => {
        // Sequence Animation
        // Canvas setup
        const canvas = document.querySelector(".sequence-canva>canvas");
        if (!canvas) { return}
        const context = canvas?.getContext("2d");
        canvas.width = 780;
        canvas.height = 780;

        const frameCount = 151;
        const currentFrame = (index) => 
        `https://cdn.shopify.com/s/files/1/0758/7331/files/MM815-${(index + 1).toString().padStart(1, "0")}.png`;
        

        const images = [];
        const sequence = { frame: 0 };

        // Preload images
        for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
        }

        // GSAP animation for the image sequence
        gsap.to(sequence, {
            frame: frameCount - 1,
            snap: "frame",
            ease: "none",
            scrollTrigger: {
                trigger: ".image-sequence-with-text",
                start: "top top",
                end: "+=4000",
                scrub: 0.05,
                pin: true,
                markers: false,
            },
            onUpdate: render
        });        

        // Render the first frame on load
        images[0].onload = render;

        function render() {
        scaleImage(images[sequence.frame], context);
        }

        function scaleImage(img, ctx) {
        const canvas = ctx.canvas;
        const hRatio = canvas.width / img.width;
        const vRatio = canvas.height / img.height;
        const ratio = Math.max(hRatio, vRatio);
        const centerShiftX = (canvas.width - img.width * ratio) / 2;
        const centerShiftY = (canvas.height - img.height * ratio) / 2;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(
            img,
            0,
            0,
            img.width,
            img.height,
            centerShiftX,
            centerShiftY,
            img.width * ratio,
            img.height * ratio
        );
        }

        // Text animation setup
        const texts = gsap.utils.toArray(".sequence-content .content");
        const totalScrollDuration = 3.5; // Set a total scroll duration for the text animation
        const position = totalScrollDuration / texts.length;

        // Create a timeline for text animation
        const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".image-sequence-with-text",
            start: "top top",
            end: "+=4500",
            scrub: true,
            pin: false // Optional: If you don't want to pin the texts
        }
        });

        // Animate each text element
        texts.forEach((text, i) => {
        const prevText = texts[i - 1];

        // Fade in the current text
        if (i) {
            tl.to(
            text,
            {
                opacity: 1,
                // duration: 1 // Smooth fade duration
            },
            position * i // Position animation based on index
            );
        }

        // Fade out the previous text
        if (prevText) {
            tl.to(
            prevText,
            {
                // y:-300,
                opacity: 0,
                // duration: 1 // Smooth fade duration
            },
            "<" // Align with the current animation
            );
        }
        });
    });

    mm.add("(min-width:992px)", () => {


        // Image parallax

        let cardTimeline = gsap.timeline()
        .fromTo('.img-parallax-animation .swiper-slide img', { yPercent: -50 }, { yPercent: 0, duration: 1, ease: "none" });
        ScrollTrigger.create({
            trigger: '.img-parallax-animation',
            animation: cardTimeline,
            start: 'top bottom',
            end: 'bottom-=40% top',
            scrub: true,
            pin: false,
            invalidateOnRefresh: false,
            markers: false
        });
      
    });

    // Stack Banner Image
    let sections = gsap.utils.toArray(".swipe-section .stacked-banner");
    let totalHeight = window.innerHeight * sections.length * 1.5; // Increased height for smoother transition
    
    sections.forEach((container, i) => {
        // Add spacer only if it's NOT the last section
        if (i !== sections.length - 1) {
            let spacer = document.createElement("div");
            spacer.style.height = `${window.innerHeight * 0.5}px`; // Adjust blank scroll height
            spacer.classList.add("spacer"); // Add a class for styling if needed
            container.parentNode.insertBefore(spacer, container.nextSibling); // Insert after each section
        }
    
        let StackSt = ScrollTrigger.create({
            trigger: container,
            start: "top top",
            end: i === sections.length - 1 ? "bottom bottom" : `+=${totalHeight + 5000}`, // Increase duration for smoother effect
            pin: true,
            pinSpacing: false,
            scrub: 5, // Higher value for slower, smoother effect
            markers: false
        });
    });
    
        
    
    
    

    mm.add("(min-width:1200px)", () => {
        // Footer Parallax
        const footer = document.querySelector('.footer-main');
        const footerHeight = footer ? footer.offsetHeight : 0;

        gsap.set('.footer-main', { y: -footerHeight });

        const uncover = gsap.timeline({ paused: true });
        uncover.to('.footer-main', { y: 0, ease: 'none', duration: 1 });

    
        ScrollTrigger.create({
            trigger: '.featured-blog-posts', 
            start: 'bottom bottom', 
            end: `+=${footerHeight}`,
            animation: uncover,
            scrub: true 
        });

        gsap.to('.footer-main', {y: 0, ease: 'none', duration: 1,
            scrollTrigger: {
                trigger: '.footer-main',
                start: 'top bottom', 
                end: 'bottom bottom', 
                scrub: true 
            }
        });
    });
    

    mm.add("(max-width:767px)", () => {
        let siteLoaded = true;
        // sessionStorage.getItem('site-loader-loaded') == 'true'
        // if(siteLoaded) {
        //     document.querySelector('.site-loader')?.classList.add('d-none');
        //     gsap.timeline({
        //         onComplete: () => {
        //             document.body.classList.remove('scroll-fixed-loader');
        //         }
        //     })
        //     .fromTo('.hero-content',{yPercent: -20, opacity: 0, duration: 1},{yPercent: 0, opacity: 1, duration: 1}, '-=0.7')
        //     .from('.hero-swiper-pagination', {opacity: 0, duration: 1});
        // } else {
        //     document.body.classList.add('scroll-fixed-loader');
        //     gsap.timeline({
        //         onComplete: () => {
        //             document.body.classList.remove('scroll-fixed-loader');
        //         }
        //     })
        //     .to(".site-loader", {yPercent:-100, duration: 1, delay: 2, ease:"none"})
        //     .fromTo('.hero-content',{yPercent: -20, opacity: 0, duration: 1},{yPercent: 0, opacity: 1, duration: 1}, '-=0.7')
        //     .from('.hero-swiper-pagination', {opacity: 0, duration: 1});
        //     sessionStorage.setItem('site-loader-loaded', 'true');
        // }

        gsap.fromTo('.hero-content',{yPercent: -20, opacity: 0, duration: 1},{yPercent: 0, opacity: 1, duration: 1}, '-=0.7')
        gsap.from('.hero-swiper-pagination', {opacity: 0, duration: 1});


        let meetTimeline = gsap.timeline()
        .from('.products-list .heading-bar h2',{ y: 50, opacity: 0, duration: 1, ease: "none" })
        .from('.products-list .swiper-slide img',{ y: 100, opacity: 0, duration: 1, ease: "none" });
        ScrollTrigger.create({
            trigger: '.products-list',
            animation: meetTimeline,
            start: 'top 80%',
            scrub: false,
            markers: false
        });

        let scaletTimeline = gsap.timeline()
        .from('.banner-with-text-slider .banner__content h2',{ y: 50, opacity: 0, duration: 1, ease: "none" })
        .from('.banner-with-text-slider .banner__content .lead-text',{ y: 50, opacity: 0, duration: 1, ease: "none" })
            ScrollTrigger.create({
                trigger: '.banner-with-text-slider',
                animation: scaletTimeline,
                start: 'top 10%',
                scrub: false,
                markers: false,
                onEnter: () => {
                    document.querySelector('.scale-animation').classList.add('completed');
                }
            });
    })

});